// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-footer-country[data-v-2881c860]{display:flex;flex-direction:row;align-items:center;justify-content:center}.app-footer-country__icon[data-v-2881c860]{width:24px;height:16px}.app-footer-country__text[data-v-2881c860]{font-size:12px;font-weight:400;--text-opacity:1;color:#8e8e8e;color:rgba(142,142,142,var(--text-opacity));margin-left:.5rem}", ""]);
// Exports
module.exports = exports;
